// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2SjNN","imageUploader":"EGiftCard_imageUploader__3-87X"};